import { client } from "./client";

interface IResponseYear {
  ActivateEnrollmentEndDatePT: string;
  ActivateEnrollmentStartDatePT: string;
  DisplayYearEndDatePT: string;
  DisplayYearStartDatePT: string;
  Year: number;
}
type IResponseStringResources = Array<{
  Name: string;
  Value: string;
}>;

export class Year {
  ActivateEnrollmentEndDatePT: Date;
  ActivateEnrollmentStartDatePT: Date;
  DisplayYearEndDatePT: Date;
  DisplayYearStartDatePT: Date;
  Year: number;

  constructor(year: IResponseYear) {
    this.ActivateEnrollmentEndDatePT = this._getLocalizedTime(
      year.ActivateEnrollmentEndDatePT
    );
    this.ActivateEnrollmentStartDatePT = this._getLocalizedTime(
      year.ActivateEnrollmentStartDatePT
    );
    this.DisplayYearEndDatePT = this._getLocalizedTime(
      year.DisplayYearEndDatePT
    );
    this.DisplayYearStartDatePT = this._getLocalizedTime(
      year.DisplayYearStartDatePT
    );
    this.Year = Number(year.Year);
  }

  get shouldDisplay() {
    let now = new Date();

    return now > this.DisplayYearStartDatePT && now < this.DisplayYearEndDatePT;
  }

  get canEnroll() {
    let now = new Date();

    return (
      now > this.ActivateEnrollmentStartDatePT &&
      now < this.ActivateEnrollmentEndDatePT
    );
  }

  _getLocalizedTime(date: string) {
    return new Date(date + "-07:00");
  }
}

class YearAndStringResources {
  request: Promise<{
    years: Year[];
    stringResources: IResponseStringResources;
  }>;
  zips = new Map();

  constructor() {
    this.request = client
      .get<{
        StringResource: IResponseStringResources;
        Years: IResponseYear[];
      }>("", {
        params: {
          methodName: "getYearAndStringResource",
        },
      })
      .then(({ data }) => {
        return {
          years: data.Years.map((year) => new Year(year)),
          stringResources: data.StringResource,
        };
      })
      .catch((error) => {
        console.log("Error fetching year and string resources:", error);
        throw error;
      });
  }

  async getYears() {
    return this.request.then(({ years }) =>
      years.filter((y) => y.shouldDisplay)
    );
  }

  async getYearsForZip(zip: string) {
    if (!this.zips.has(zip)) {
      this.zips.set(
        zip,
        client
          .get<{
            AvailableYear: Array<{
              year: number;
            }>;
          }>("", {
            params: {
              methodName: "getYearByZipCode",
              zipcode: zip,
            },
          })
          .then((response) =>
            response.data.AvailableYear.map((year) => Number(year.year))
          )
          .catch((error) => {
            console.log(`Error fetching years for zip ${zip}:`, error);
            throw error;
          })
      );
    }

    const [zipYears, request] = await Promise.all([
      this.zips.get(zip),
      this.request,
    ]);

    return request.years.filter(
      (year) => year.shouldDisplay && zipYears.includes(year.Year)
    );
  }

  async getStringResource(name: string) {
    return this.request.then(
      ({ stringResources }) =>
        stringResources.find((i) => i.Name === name)?.Value
    );
  }
}

export const yearAndStringResources = new YearAndStringResources();
